"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAttribution = exports.event = exports.DEDUPE_EVENTS = exports.SECURE_EVENTS = exports.session = exports.TELEMETRY_ATTRIBUTION = exports.TELEMETRY_EVENT = exports.TELEMETRY_SESSION = exports.TELEMETRY = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _ajax = require("./ajax");

var _constants = require("../constants");

var _URLS;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var TELEMETRY = 'TELEMETRY';
exports.TELEMETRY = TELEMETRY;
var TELEMETRY_SESSION = "".concat(TELEMETRY, "::SESSION");
exports.TELEMETRY_SESSION = TELEMETRY_SESSION;
var TELEMETRY_EVENT = "".concat(TELEMETRY, "::EVENT");
exports.TELEMETRY_EVENT = TELEMETRY_EVENT;
var TELEMETRY_ATTRIBUTION = "".concat(TELEMETRY, "::ATTRIBUTION");
exports.TELEMETRY_ATTRIBUTION = TELEMETRY_ATTRIBUTION;
var URLS = (_URLS = {}, (0, _defineProperty2["default"])(_URLS, _constants.CONTEXTS.EXTERNAL, "/ft/external"), (0, _defineProperty2["default"])(_URLS, _constants.CONTEXTS.LOCAL, "/ft/local"), (0, _defineProperty2["default"])(_URLS, _constants.CONTEXTS.SECURE, "/ft/secure"), _URLS);
var SESSION_DATA = {
  platform: 'WEB',
  libVersion: "0.6.2"
};
/**
 * Secure endpoints support USER and APP events and represent the user's logged in state. A secure session must be created before sending a secure event.
 * To force request a new session, remove sessionKey from the request.
 * If sessionKey is included then it will validate that its active.
 * - If its valid then it will be returned in the response.
 * - If not then a new session be created and returned.
 *
 * @param data
 * @param [data.sessionKey]
 * @param {string} data.sessionKey.uuid
 * @param {string} data.sessionKey.trackerUuid
 * @param {Number} data.sessionKey.epoch
 * @param {string} data.appVersion
 * @param {string} context - the current api context
 */

var session = function session(data) {
  var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _constants.CONTEXTS.SECURE;
  return /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(dispatch) {
      var _document, _window, _window$location, _window2, _window2$screen, _window3, _window3$screen, _window4, _window5;

      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", (0, _ajax.ajaxPost)(TELEMETRY_SESSION, dispatch, "".concat((0, _ajax.baseUrl)()).concat(URLS[context], "/session"), _objectSpread(_objectSpread({}, SESSION_DATA), {}, {
                referrer: ((_document = document) === null || _document === void 0 ? void 0 : _document.referrer) || '',
                queryParams: ((_window = window) === null || _window === void 0 ? void 0 : (_window$location = _window.location) === null || _window$location === void 0 ? void 0 : _window$location.search) || '',
                screenWidth: ((_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$screen = _window2.screen) === null || _window2$screen === void 0 ? void 0 : _window2$screen.width) || 0,
                screenHeight: ((_window3 = window) === null || _window3 === void 0 ? void 0 : (_window3$screen = _window3.screen) === null || _window3$screen === void 0 ? void 0 : _window3$screen.height) || 0,
                windowWidth: ((_window4 = window) === null || _window4 === void 0 ? void 0 : _window4.innerWidth) || 0,
                windowHeight: ((_window5 = window) === null || _window5 === void 0 ? void 0 : _window5.innerHeight) || 0
              }, data), null, null, false, true));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};

exports.session = session;
var SECURE_EVENTS = ['APP', 'USER'];
exports.SECURE_EVENTS = SECURE_EVENTS;
var DEDUPE_EVENTS = ['APP'];
/**
 * External context supports WEB events where applicationUuid and productType are not required.
 * Secure context supports APP and USER events where applicationUuid and productType are required.
 * Dedupe signals that the event should be unique and returned with the session response
 * By default, dedupe is true for APP events and false for all others
 *
 * @param data
 * @param data.sessionKey
 * @param {string} data.sessionKey.uuid
 * @param {string} data.sessionKey.trackerUuid
 * @param {Number} data.sessionKey.epoch
 * @param {string} data.eventType
 * @param {string} data.event
 * @param {string} [data.identityId] must exist for eventType of USER
 * @param {string} [data.applicationUuid] must exist for eventType of APP
 * @param {string} [data.productType] must exist for SECURE_EVENTS
 * @param {string} [data.dedupeProperty] property to dedupe
 * @param {boolean} [data.dontDedupe] override server side dedupe
 * @param {object} [data.eventProperties] {"k1": "v1",} etc, all values must be strings
 * @param {object} [data.profile] the profile object in Figure land
 * @param {string} context - the current api context
 */

exports.DEDUPE_EVENTS = DEDUPE_EVENTS;

var event = function event(data) {
  var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _constants.CONTEXTS.SECURE;
  return /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(dispatch) {
      var _document2, _window6, _window6$location, _document3, _document3$location;

      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", (0, _ajax.ajaxPost)(TELEMETRY_EVENT, dispatch, "".concat((0, _ajax.baseUrl)()).concat(URLS[context], "/event"), _objectSpread({
                domain: ((_document2 = document) === null || _document2 === void 0 ? void 0 : _document2.domain) || '',
                queryParams: ((_window6 = window) === null || _window6 === void 0 ? void 0 : (_window6$location = _window6.location) === null || _window6$location === void 0 ? void 0 : _window6$location.search) || '',
                pagePath: ((_document3 = document) === null || _document3 === void 0 ? void 0 : (_document3$location = _document3.location) === null || _document3$location === void 0 ? void 0 : _document3$location.pathname) || ''
              }, data), null, null, false));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};

exports.event = event;

var getAttribution = function getAttribution(_ref3) {
  var appUuid = _ref3.appUuid,
      event = _ref3.event,
      product = _ref3.product;
  var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _constants.CONTEXTS.SECURE;
  return /*#__PURE__*/function () {
    var _ref4 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(dispatch) {
      return _regenerator["default"].wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", (0, _ajax.ajaxGet)(TELEMETRY_ATTRIBUTION, dispatch, "".concat((0, _ajax.baseUrl)()).concat(URLS[context], "/attribution/").concat(product, "/").concat(appUuid, "/").concat(event), null, null, false));

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x3) {
      return _ref4.apply(this, arguments);
    };
  }();
};

exports.getAttribution = getAttribution;